import React from "react";
import { useHistory } from "react-router";
import ModuleHeader from "../modules/ModuleHeader";
import { useClearCurrentTopic } from "../../hooks/useClearCurrentTopic";

const Story = () => {
  const history = useHistory();
  useClearCurrentTopic();

  return (
    <div>
      <ModuleHeader
        bgColor="white"
        color="darkgray"
        hoverColor="black"
        title=""
        showBackButton={false}
        backUrl={`/app`}
      />

      <div className="content-area flex-grow">
        <div className="inner-content px-15 sm:px-55 lg:px-15 mx-auto pb-25 lg:pb-8">
          <div className="text-gray-800 text-base leading-normal tracking-slightwide font-primary pt-47 pb-33">
            <strong className="block mb-20">Your Project</strong>
            <p>
              You recently joined a product development team that has been
              tasked with creating an automated garden box that uses live
              weather data to keep the plants inside it happy. Your team
              nicknamed the product the "GrowBot."
            </p>
            <p>
              GrowBot will monitor and correct the temperature, water, and sun
              levels in the garden box, and the user can control it with their
              phone.
            </p>
            <p className="mb-0">
              And by the way, you will be managing this project!
            </p>
            <div className="text-center -mx-40 md:mx-0 py-50">
              <img
                className="inline-block align-top"
                src="images/pages/005.gif"
                alt=" description"
                width="340"
                height="255"
              />
            </div>
            <p className="text-center">
              <button
                onClick={() => history.goBack()}
                className="inline-block align-top uppercase text-eggblue hover:text-gray-800 font-secondary font-bold"
              >
                done
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Story;
